var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50.75px",
    height: "50.5px",
    viewBox: "0 0 50.75 50.5",
    enableBackground: "new 0 0 50.75 50.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.106,43.175L26.394,7.306c-0.295-0.48-0.818-0.773-1.383-0.773c-0.564,0-1.087,0.293-1.382,0.773L4.915,43.175 c-0.252,0.482-0.234,1.062,0.049,1.528c0.283,0.467,0.788,0.752,1.334,0.752h37.427c0.545,0,1.052-0.285,1.334-0.752 C45.342,44.237,45.36,43.657,45.106,43.175L45.106,43.175z M8.869,42.336L25.01,11.398l16.14,30.938H8.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,37.658c0,0.86-0.698,1.56-1.56,1.56c-0.861,0-1.56-0.699-1.56-1.56c0-0.861,0.698-1.561,1.56-1.561 C25.873,36.098,26.57,36.797,26.57,37.658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.451,22.062v10.916c0,0.558,0.297,1.072,0.78,1.352c0.482,0.277,1.077,0.277,1.56,0c0.482-0.279,0.78-0.794,0.78-1.352 V22.062c0-0.557-0.298-1.072-0.78-1.35c-0.483-0.279-1.078-0.279-1.56,0C23.748,20.991,23.451,21.505,23.451,22.062z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2138ad98.svg";
export { ForwardRef as ReactComponent };